<template>
  <div>
      <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 text-center mb-4">
              <h4 class="mb-0">
                Ingresa tu dirección
              </h4>
              <small>Los campos marcados con * son obligatorios.</small>
            </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <div :class="{'is-invalid': $v.address.address_1.$invalid, 'form-group': true}">
                      <label for="address_1-input">{{$t('form.address_1')}}</label>
                      <input type="text"
                      class="form-control"
                      v-model="address.address_1"
                      @input="$v.address.address_1.$touch()"
                      placeholder="">
                      <div class="form-control-feedback" v-if="!$v.address.address_1.required">
                      {{ $t('form.required') }}
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <div :class="{'is-invalid': $v.address.address_2.$invalid, 'form-group': true}">
                      <label for="address_2-input">{{$t('form.address_2')}}</label>
                      <input type="text"
                      class="form-control"
                      v-model="address.address_2"
                      @input="$v.address.address_2.$touch()"
                      placeholder="">
                      <div class="form-control-feedback" v-if="!$v.address.address_2.required">
                      {{ $t('form.required') }}
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-4">
                  <div :class="{'is-invalid': $v.address.city.$invalid, 'form-group': true}">
                      <label for="city-input">{{$t('form.city')}}</label>
                      <input type="text"
                      class="form-control"
                      v-model="address.city"
                      @input="$v.address.city.$touch()"
                      placeholder="">
                      <div class="form-control-feedback" v-if="!$v.address.city.required">
                      {{ $t('form.required') }}
                      </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div :class="{'is-invalid': $v.address.state.$invalid, 'form-group': true}">
                    <label for="state-input">{{$t('form.state')}}</label>
                    <select
                      class="form-control"
                      @input="$v.address.state.$touch()"
                      v-model="address.state">
                      <option :value="state.value"  v-for="(state, index) in statesUSA" :key="index">
                        {{state.label}}
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.address.state.required">
                      {{ $t('form.required') }}
                    </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div :class="{'is-invalid': $v.address.postcode.$invalid, 'form-group': true}">
                      <label for="postcode-input">{{$t('form.postcode')}}</label>
                      <input type="text"
                      class="form-control"
                      v-model="address.postcode"
                      @input="$v.address.postcode.$touch()"
                      placeholder="">
                      <div class="form-control-feedback" >
                        <span v-if="!$v.address.postcode.required">
                          {{ $t('form.required') }}
                        </span>
                        <span v-if="!$v.address.postcode.minLength">
                          {{ $t('form.zip_minlength') }}
                        </span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <pre>
        {{statusForm}}
      </pre> -->
  </div>
</template>

<script>
// eslint-disable-next-line
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators'

export default {
  name: 'FormStepThree',
  props: [
    'data'
  ],
  data () {
    return {
      step: 1,
      test: 'lorem',
      address: {
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        postcode: ''
      }
    }
  },
  validations: {
    address: {
      address_1: {
        required
      },
      address_2: {
      },
      city: {
        required
      },
      state: {
        required
      },
      postcode: {
        required,
        minLength: minLength(5)
      }
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    statusForm () {
      return this.$v.address.$invalid
    },
    statesUSA () {
      return this.$store.state.statesUSA
    }
  },
  watch: {
    // isValid (value) {
    //   if (value === false) {
    //     this.$emit('valid-data', [this.personal, this.isValid, this.step])
    //   } else {
    //     this.$emit('valid-data', [this.personal, this.isValid, this.step])
    //   }
    //   // this.$emit('valid-form', this.isValid)
    // }
  },
  mounted () {
  },
  methods: {
    validate () {
      console.log('validando')
      this.$v.address.$touch()
      var isValid = !this.$v.address.$invalid
      console.log('es valido', isValid)
      this.$emit('on-validate', this.address, isValid)
      return isValid
    }
  }
}
/* {
  payment_token: 'tok_1Cm8XFG9eOPeXBTVIxjYNHIF',
  user: {
    username: 'test56ApiRest',
    password: 'Qwerty123'
  },
  data: {
    product_id: 406,
    payment_period: 'Mensual',

    first_name: 'Test56',
    last_name: 'ApiRest',
    email: 'test56apirest@yopmail.com',
    mobile_phone: '1234567890',
    birthdate: '1981-10-07',

    seller_id: 'socio-211',

    address_1: 'Test Avenue',
    address_2: '1200',
    city: 'Houston',
    state: 'TX',
    postcode: '77001',

    SSN: '234234234234',
    ITIN: '234234324234324'
  },
  add_kit: true
} */
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/FormStepThree.vue